import React from 'react'

const QuarterlyReportIcon = ({props}) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="currentColor"
        {...props}
    >
        <path 
            d="M16 2L21 7V21.0082C21 21.556 20.5551 22 
            20.0066 22H3.9934C3.44476 22 3 21.5447 3 
            21.0082V2.9918C3 2.44405 3.44495 2 3.9934
            2H16ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091
            9.79086 16 12 16C14.2091 16 16 14.2091 16 12H12V8Z"
        >
        </path>
    </svg>
  )

export default QuarterlyReportIcon